"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Breadcrumb = /*#__PURE__*/function (_React$Component) {
  _inherits(Breadcrumb, _React$Component);

  var _super = _createSuper(Breadcrumb);

  function Breadcrumb() {
    _classCallCheck(this, Breadcrumb);

    return _super.apply(this, arguments);
  }

  _createClass(Breadcrumb, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          links = _this$props.links,
          location = _this$props.location,
          themeWrapper = _this$props.themeWrapper;
      var secondLastItem = links.length - 2;

      var Link = function Link(props) {
        var isSecondLastItem = secondLastItem === props.index;
        return /*#__PURE__*/_react.default.createElement("span", {
          className: (0, _classnames.default)('', {
            'none inline-block-mm': !isSecondLastItem
          })
        }, isSecondLastItem && /*#__PURE__*/_react.default.createElement("span", {
          className: "color-gray-light inline-block none-mm pr6"
        }, /*#__PURE__*/_react.default.createElement(_icon.default, {
          name: "arrow-left",
          inline: true
        })), /*#__PURE__*/_react.default.createElement("a", {
          className: "link",
          href: props.href
        }, props.children), /*#__PURE__*/_react.default.createElement("span", {
          className: "color-gray-light inline-block-mm none px6"
        }, /*#__PURE__*/_react.default.createElement(_icon.default, {
          name: "chevron-right",
          inline: true
        })));
      };

      return links.length > 1 ? /*#__PURE__*/_react.default.createElement("div", {
        className: "dr-ui--breadcrumb ".concat(themeWrapper),
        "data-swiftype-index": "false"
      }, links.map(function (link, index) {
        return link.path !== location.pathname ? /*#__PURE__*/_react.default.createElement(Link, {
          key: link.title,
          href: link.path,
          index: index
        }, link.title) : /*#__PURE__*/_react.default.createElement("span", {
          key: link.title,
          className: "color-gray none inline-block-mm"
        }, link.title);
      })) : null;
    }
  }]);

  return Breadcrumb;
}(_react.default.Component);

exports.default = Breadcrumb;
Breadcrumb.propTypes = {
  /** Array of links to build the breadcrumb */
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    path: _propTypes.default.string.isRequired
  })),

  /** Current page pathname */
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string.isRequired
  }).isRequired,

  /** Assembly classes to apply to the containing wrapper */
  themeWrapper: _propTypes.default.string
};
Breadcrumb.defaultProps = {
  themeWrapper: ''
};